import { useMemo } from 'react';
import { useAppSelector } from '@/hooks/useAppSelector';
import { detectBrowserCountryCode } from '@/utils/phoneCountries';
import { resolveCountryCode, useCurrentOrganization } from '@/hooks/useCurrentOrganization';
import { useMasterData } from '@/hooks/useMasterData';

/** Default phone country: explicit override → org country (signed-in only) → browser location → India. */
export function useDefaultPhoneCountry(override?: string): string {
  const isAuthenticated = useAppSelector((s) => s.auth.isAuthenticated);
  const { data: org } = useCurrentOrganization(isAuthenticated && !override);
  const { countries } = useMasterData();

  return useMemo(() => {
    if (override) return override.toUpperCase();
    if (org?.countryCode) return org.countryCode.toUpperCase();
    const resolved = org ? resolveCountryCode(org, countries) : '';
    if (resolved) return resolved.toUpperCase();
    return detectBrowserCountryCode();
  }, [override, org, countries]);
}
